export default __webpack_public_path__ + "locales/sq-AL/DeleteThirdPartyDialog.json?hash=3cb451826aa54089f8c41b3533e9e63e";